import { Bindable, NotifyProperty, nameof } from "bindable-data";
import { injectable } from "@launchtray/tsyringe-async";
import { IUseDiscountViewModel } from "./IUseDiscountViewModel";

@injectable()
export class UseDiscountViewModel extends Bindable implements IUseDiscountViewModel {
    public readonly summaryDiscountPercentage: NotifyProperty<number>;
    public readonly appliedCoupons: NotifyProperty<Array<string>>;

    public constructor() {
        super();
        this.summaryDiscountPercentage = new NotifyProperty<number>(this, nameof(this, "summaryDiscountPercentage"), 1);
        this.appliedCoupons = new NotifyProperty<Array<string>>(this, nameof(this, "appliedCoupons"), []);
    }
}
